import axiosInterceptor from "../../utils/axiosInterseptor";

export const dashboardCountRoute = () =>
  axiosInterceptor.get("/admin/userListingOnDeshboard");

export const feedbackRoute = (queryParam) =>
  axiosInterceptor.get("/admin/feedListing" + queryParam);
